export default __webpack_public_path__ + "static/media/Belt of the Scattered Gods.36f387ea.jpg";